import { Link } from "react-router-dom";
import { useT } from "../../i18n";

const ACTIONS = [
  { key: "addVehicle", href: "/company/listings/new" },
  { key: "viewRequests", href: "/company/bookings" },
  { key: "manageSubscription", href: "/company/subscription" },
] as const;

export default function QuickActions() {
  const t = useT();
  return (
    <section className="grid gap-2 rounded-card bg-white p-5">
      <h2 className="m-0 mb-1 text-base font-medium">{t.common.quickActions}</h2>
      {ACTIONS.map((a) => (
        <Link
          key={a.href}
          to={a.href}
          className="flex h-10 items-center rounded bg-surface px-3.5 text-sm font-medium text-ink no-underline transition-colors hover:bg-surface-hover"
        >
          {t.company.overview.actions[a.key]}
        </Link>
      ))}
    </section>
  );
}
